var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaticOtp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6 4.4C6.6 4.18783 6.68429 3.98434 6.83431 3.83431C6.98434 3.68429 7.18783 3.6 7.4 3.6H17C17.2122 3.6 17.4157 3.68429 17.5657 3.83431C17.7157 3.98434 17.8 4.18783 17.8 4.4V20.4C17.8 20.6122 17.7157 20.8157 17.5657 20.9657C17.4157 21.1157 17.2122 21.2 17 21.2H7.4C7.18783 21.2 6.98434 21.1157 6.83431 20.9657C6.68429 20.8157 6.6 20.6122 6.6 20.4V4.4ZM7.4 2C6.76348 2 6.15303 2.25286 5.70294 2.70294C5.25286 3.15303 5 3.76348 5 4.4V20.4C5 21.0365 5.25286 21.647 5.70294 22.0971C6.15303 22.5471 6.76348 22.8 7.4 22.8H17C17.6365 22.8 18.247 22.5471 18.6971 22.0971C19.1471 21.647 19.4 21.0365 19.4 20.4V4.4C19.4 3.76348 19.1471 3.15303 18.6971 2.70294C18.247 2.25286 17.6365 2 17 2H7.4ZM9.8 19.04C9.65148 19.04 9.50904 19.099 9.40402 19.204C9.299 19.309 9.24 19.4515 9.24 19.6C9.24 19.7485 9.299 19.891 9.40402 19.996C9.50904 20.101 9.65148 20.16 9.8 20.16H14.6C14.7485 20.16 14.891 20.101 14.996 19.996C15.101 19.891 15.16 19.7485 15.16 19.6C15.16 19.4515 15.101 19.309 14.996 19.204C14.891 19.099 14.7485 19.04 14.6 19.04H9.8Z",
    fill: "#5D6679"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticOtp);
export default __webpack_public_path__ + "static/media/StaticOTP.6d10ea30392393974b7bc0e890437d49.svg";
export { ForwardRef as ReactComponent };